<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import Our_Services from "@/assets/json/our-services.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      Our_Services: Our_Services,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
<template>
  <div class="accordion-item mb-3">
    <div class="accordion-header" id="accordion-headingFour">
      <div
        class="accordion-button p-0"
        data-bs-toggle="collapse"
        data-bs-target="#accordion-collapseFour"
        aria-expanded="true"
        aria-controls="accordion-collapseFour"
        role="button"
      >
        Our Services
      </div>
    </div>
    <div
      id="accordion-collapseFour"
      class="accordion-collapse collapse show"
      aria-labelledby="accordion-headingFour"
    >
      <div class="accordion-body p-0 mt-3 pb-1">
        <div class="row">
          <div class="col-md-12">
            <div class="our-services-slider custom-owl-dot owl-carousel">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in Our_Services" :key="item.id">
                  <div class="card text-start">
                    <div class="card-body">
                      <div class="img-sec w-100 mb-3">
                        <router-link to="/details/service-details"
                          ><img
                            :src="require(`@/assets/img/services/${item.Image}`)"
                            class="img-fluid rounded w-100"
                            alt="img"
                        /></router-link>
                      </div>
                      <div>
                        <h5 class="mb-2 text-truncate">
                          <router-link to="/details/service-details">{{ item.Name }}</router-link>
                        </h5>
                        <div
                          class="d-flex justify-content-between align-items-center mb-2"
                        >
                          <p class="fs-14 mb-0">
                            <i class="ti ti-map-pin me-2"></i>{{ item.Location }}
                          </p>
                          <span class="rating text-gray fs-14"
                            ><i class="fa fa-star filled me-1"></i>{{ item.Rating }}</span
                          >
                        </div>
                        <div>
                          <span>Starts From</span>
                          <h6 class="text-primary fs-16 mt-1">
                            {{ item.Amount }}
                            <small
                              class="text-decoration-linethrow fs-14 fw-normal text-gray"
                              >{{ item.Price }}
                            </small>
                            <span class="fs-14 fw-normal text-gray"> /hr</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slide>
                <template #addons>
                  <Navigation />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
